import { MainAppResource } from './base';

export default MainAppResource(
  'api/v3/waveforms/{waveform-id}/waveform_detail',
  {},
  {
    fetch: { method: 'GET' },
    patch: { method: 'PATCH' }
  }
);
